import { cn } from '@components/shadcn/utils';
import React from 'react';
import type { Property } from '../../../core/models/properties';
import { AnomalyInformationTooltip } from './AnomalyInformationTooltip/AnomalyInformationTooltip';

interface IPropertyListItemProps {
  property: Property;
  selected: boolean;
  onClick?: (p: Property) => void;
  isLoadingAnomalyData?: boolean;
  anomalyData?: {
    quantity?: number;
    area?: number;
  };
}

export const PropertyListItem: React.FC<IPropertyListItemProps> = ({
  property,
  onClick,
  selected,
  anomalyData,
  isLoadingAnomalyData,
}) => {
  const onClickItem = () => {
    if (onClick) onClick(property);
  };

  if (!property.field_count) return null;

  return (
    <button
      type="button"
      onClick={onClickItem}
      className={cn(
        'w-full max-w-80 py-1 pl-3.5 pr-2.5 text-start rounded-md hover:bg-sy-blue-10',
        {
          ['bg-sy-blue-10 font-semibold']: selected,
        }
      )}
    >
      <div className="flex justify-between items-center gap-2">
        <div className={cn('w-full', { ['w-4/5']: anomalyData })}>
          <p className="truncate" title={property.name}>
            {property.name}
          </p>
        </div>
        {anomalyData ? (
          <AnomalyInformationTooltip
            isLoadingAnomalyData={isLoadingAnomalyData}
            anomalyData={anomalyData}
          />
        ) : null}
      </div>
    </button>
  );
};
